import React from 'react';

/*
 *  @Description:   Stateless component that renders a SearchIcon (Magnifier).
 */

const Search = ( props ) => {

    return (
        <g id="path">
            <circle cx="10" cy="10" r="7"/>
            <line x1="21" y1="21" x2="15" y2="15"/>
        </g>

    )

};


export default Search;

